import toast from 'react-hot-toast';
import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { VrnDetails } from '../types/VRNDetails';
import { FastagStatus, StatusMapping } from '../constants';
import { formatStatusPopupData } from '../utils';
import { isNumeric } from 'core-lib/utils/regex';
import { DictType } from 'core-lib/types/Helper';

function serialize(data: DictType) {
  const result: VrnDetails = {
    isChasis: !!data?.is_chasis ?? false,
    status:
      data?.fastag_status &&
      StatusMapping[data.fastag_status.toUpperCase().replaceAll(' ', '_')],
    isVrnTagListHitNeeded: data?.is_vrn_tag_list_hit_needed,
  };
  result.vehicle = {
    owner: data?.owner_name,
    brandLogo: data?.brand_model_mapping?.brand_icon,
    number: data?.vehicle_number,
    brandName: data?.brand_model_mapping?.brand_name,
    model: data?.brand_model_mapping?.model_name,
  };
  result.bank = {
    logo: data?.bank_detail?.bank_icon_url,
    id: data?.bank_detail?.bank_id,
    name: data?.bank_detail?.bank_name,
  };
  result.billerId = data.bank_detail?.biller_id;
  // result.operatorId = data.operator_id;
  result.balance = {
    show: data?.show_balance,
    balance: data?.balance_details?.balance_amount,
    updatedAt: data?.balance_details?.balance_updated_at,
  };
  if (data?.bank_detail?.biller_id) {
    if (
      isNumeric(data?.bank_detail?.min_amount) &&
      isNumeric(data?.bank_detail?.max_amount)
    ) {
      result.minAmount = Number(data?.bank_detail?.min_amount);
      result.maxAmount = Number(data?.bank_detail?.max_amount);
    }
  }
  if (result.status !== FastagStatus.Active && data?.pop_up_display_detail) {
    result.statusPopupData = formatStatusPopupData(data.pop_up_display_detail);
  }
  return result;
}

type ResultTypes = {
  response?: VrnDetails;
  error?: any;
};

export function checkVrnDetails(
  body: DictType,
  bypassStatusCheck = false
): Promise<ResultTypes> {
  return new Promise((resolve) => {
    (async function callCheckVrnDetailsApi() {
      const url = `${apiConfig(
        'fastagIssuance'
      )}/fastag-recharge/tag/v2/vrn-detail`;
      const { response, error }: any = await postMethod({
        endPoint: url,
        body,
      });
      if (response) {
        if (response?.data) {
          if (response?.data?.fastag_status || bypassStatusCheck) {
            resolve({
              response: serialize(response.data),
            });
          } else {
            toast.error('Unable to check vrn details');
            resolve({ error: {} });
          }
        } else resolve({ error: {} });
      }
      if (error) {
        resolve({ error });
        toast.error('Unable to check vrn details');
      }
    })();
  });
}
